import { render, staticRenderFns } from "./rfq-import-quote-pdf-2.vue?vue&type=template&id=3f06a910&scoped=true"
import script from "./rfq-import-quote-pdf-2.vue?vue&type=script&lang=js"
export * from "./rfq-import-quote-pdf-2.vue?vue&type=script&lang=js"
import style0 from "./rfq-import-quote-pdf-2.vue?vue&type=style&index=0&id=3f06a910&prod&lang=css"
import style1 from "./rfq-import-quote-pdf-2.vue?vue&type=style&index=1&id=3f06a910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f06a910",
  null
  
)

export default component.exports